import React, {useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ProjectDetails.css";
import ProjectDetailsPage from "./ProjectDetailPage/ProjectDetailsPage";
import Insight from "./Insight/Insight";
import MVOC from "./MVOC/MVOC";
import SocialAnalysis from "./SocialAnalysis/SocialAnalysis";
import DigitalSource from "./DigitalSource/DigitalSource"
import { useLocation } from "react-router-dom";
import { getRouteId } from "../../constants/constant";

const ProjectDetails = () => {

  // Using useLocation to get access to current route information
  const location = useLocation();
  const project_id = getRouteId(location.pathname);

  // States to manage the project's creation stage
  const [disableMVOC, setDisableMVOC] = useState(false);
  // State to handle whether API call for MVOC is made
  const [mvocAPIcall, setMvocAPIcall] = useState(false);
  // State to check if project exists
  const [projectexist, setProjectexist] = useState(false);
  // Fetching SelectInsight values from the Redux store
  const saveSelectInsightSource = useSelector(
    (state) => state?.product?.stepCompleted
  );
  // Get the current project details from Redux store
  const currentProjectDetail = useSelector(
    (state) => state?.product?.currentProjectDetail
  );

  // 🔑 Read the selected tab from Redux
  const selectedInsight =
    useSelector((state) => state?.product?.selectedInsight) || "MVOC Insights";

  // useEffect hook to monitor changes in currentProjectDetail and set projectexist state
  useEffect(() => {
    if (currentProjectDetail && Object.keys(currentProjectDetail).length > 0) {
      setProjectexist(true);
    } else {
      setProjectexist(false);
    }
  }, [currentProjectDetail]);

  // Updating mvocAPIcall state when the API call check value changes
  const handleApicallcheck = (value) => {
    setMvocAPIcall(value);
  };
  // Disabling or enabling MVOC based on the passed value
  /**
   * Handles the change event for disabling MVOC.
   *
   * @param {boolean} value - The new value to set for disabling MVOC.
   */
  const handleDisableMVOCChange = (value) => {
    setDisableMVOC(value);
  };



  return (
    <>
      <div className="child-container">
        <ProjectDetailsPage
          projectexist={projectexist}
          onDisableMVOCChange={handleDisableMVOCChange}
        />
        {(saveSelectInsightSource === 1 ||
          saveSelectInsightSource === 2 ||
          projectexist) &&
          project_id && (
            <Insight
              project_id={project_id}
              onDisableMVOCChange={handleDisableMVOCChange}
              apiCallcheck={handleApicallcheck}
            />
          )}
        {(saveSelectInsightSource === 2 || projectexist) && project_id && (
          <>
          {selectedInsight === "MVOC Insights" && (
            <MVOC projectexist={projectexist} disableMVOC={disableMVOC} />
          )}
          {selectedInsight === "Social Media Analysis" && (
            <SocialAnalysis projectexist={projectexist} />
          )}
          {selectedInsight === "Digital Source" && (
            <DigitalSource projectexist={projectexist} />
          )}
        </>
        )}
      </div>
    </>
  );
};

export default ProjectDetails;
